export const COMPONENT_NAME = 'HeroBannerSupergraphic';